import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-6FDQ17D06T';

// Fires a GA4 page_view on every client-side route change. The gtag.js
// snippet in public/index.html loads with send_page_view:false so this is
// the single source of page views (including the first load), avoiding
// double-counting. Admin routes are excluded — staff usage shouldn't mix
// into customer analytics.
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location]);

  return null;
};

export default Analytics;
